// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc91385c","293":"6d0f1fa2","306":"ca5a082b","455":"cf8f580f","495":"0aca4544","753":"350fe0e8","977":"9bab0ed2"}[chunkId] + ".chunk.js";
};